<template>
    <div class="news__ms" v-if="$route.params.path==null">
        <main-panel>
            <template v-slot:header>
                <h2>{{$route.name}}</h2>
            </template>
        </main-panel>
        <section class="frame-padding">
            <div>
                <div class="search-ms___panel_input">
                    <input-ms placeholder="Поиск" class=""></input-ms>
                </div>
                <div  class="search__panel">
                    <div class="news__panel">
                        <panel-news-ms v-for="item in news" :key="item.id" :item="item"></panel-news-ms>
                    </div>
                </div>
                <div>
                    <paginator-ms :count="count" :count-page="length" @change="paginatorChange" @increase-count="increaseCount"></paginator-ms>
                </div>
            </div>
        </section>
    </div>
    <component :is="$route.params.path!=null?'item':''"/>
</template>
<script>
import mainPanel from '../components/main/mainPanel.vue';
import panelNewsMs from '../components/main/panelNewsMs.vue';
import inputMs from '../components/common/inputMs.vue';
import paginatorMs from '../components/common/paginatorMs.vue';
import item from '../components/news/itemMs.vue';
import axios from 'axios';

export default{
    components:{
        mainPanel,
        panelNewsMs,
        inputMs,
        paginatorMs,
        item
    },
    mounted(){
        this.getNews(this.searchText,this.start,this.length)
    },
    methods:{
        getNews(searchText ='',start=-1,length=-1){
            this.start = start
            this.length = length
            searchText
            let searchStr = '?'
            searchStr += start>-1?'start='+start+'&':''
            searchStr +=length>-1?'end='+length+'&':''
            axios
                .get('https://mosp51.ru/api/news'+searchStr,)
                .then(response=>{
                    this.news = response.data
                    this.count = response.data[0].count_news
                })
        },
        paginatorChange(start){
            this.getNews(this.searchText,start,this.length)
        },
        increaseCount(length){
            this.getNews(this.searchText,this.start,length)
        }
    },
    data(){
        return{
            count:4,
            length:10,
            start:0,
            news:[]
        }
    }
}
</script>
<style>
.news__ms .news__panel img{
    width: 644px;
}
.news__ms .news__panel{
    flex-wrap: wrap;
    row-gap: 64px;
}
.news__ms .news__panel h3{
    width:644px ;
    text-wrap: nowrap;
    height: auto;
}
.news__ms .search__panel{
    margin-top: 40px;
}
.news__ms section {
    margin-bottom: 100px;
}
.news__ms .search-ms___panel_input{
    width:644px;
}  
@media(max-width: 1000px){
    .news__ms .news__panel{
        gap:24px;
    }
    .news__ms .news__panel img,
    .news__panel>div,
    .news__ms .news__panel h3,
    .news__panel .panel.panel__shadow,
    .news__ms .search-ms___panel_input{
        width: 100%;
    }


}
</style>